import { render, staticRenderFns } from "./ProjectBadge.vue?vue&type=template&id=6b46289f&lang=pug"
import script from "./ProjectBadge.vue?vue&type=script&lang=ts"
export * from "./ProjectBadge.vue?vue&type=script&lang=ts"
import style0 from "./ProjectBadge.vue?vue&type=style&index=0&id=6b46289f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports